export enum TodayFilterValues {
  ALL_BOOKINGS = 'allBookings',
  TODAY = 'today',
}
